import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import { Select } from "antd";
import { useGetAccountsQuery } from "../../services/account";
// import "./AccountList.scss";

interface IAccountListProps {
    value?: any;
    companyId: string;
    filterFn?: any;
    onChange?: any;
    className?: string;
    placeholder?: string;
    drCr?: string | "Dr" | "Cr" | null;
}

const AccountList = (props: IAccountListProps) => {
    const { value, companyId, filterFn, onChange, className, placeholder, drCr } = props;
    const dropdownFilterOption = (input: any, option: any) => {
        const opt = option.props?.searchText;
        return ((opt as string) ?? "").toLowerCase().includes(input?.toLowerCase() ?? "")
    }

    const {
        data: getAccountsResponse,
        isLoading: accountsLoading,
        isSuccess: loadingSuccess
    } = useGetAccountsQuery({ companyId, isGroup: false });


    return (<>
        <Select
            className={`account-list ${className}`}
            onChange={onChange}
            filterOption={dropdownFilterOption}
            showSearch
            allowClear
            placeholder={placeholder || "Select account"}
            loading={accountsLoading}
            value={value}
            options={
                loadingSuccess &&
                getAccountsResponse?.data?.map((account: any) => ({
                    label: <div><span style={{ color: "#ccc" }}>{account.accountNo}</span> {account.accountTitle}</div>,
                    value: account.id,
                    accountNo: account.accountNo,
                    accountTitle: account.accountTitle,
                    accountBalance: account.currentBalance,
                    searchText: `${account.accountNo} ${account.accountTitle}`
                })
                )
            }
            optionRender={(option: any) => {
                return (<div className={`account-row float-left w-[100%]`} style={{ color: option.data?.accountBalance < 0 ? "red" : "black", borderBottom: "1px solid #ccc" }}>
                    <div className="account-no float-left w-[20%]">{option.data?.accountNo}</div>
                    <div className="account-title float-left w-[60%]">{option.data?.accountTitle}</div>
                    <div className="account-balance float-left w-[20%] text-right">{option.data?.accountBalance}</div>
                </div>);
            }}
            prefix={drCr && <span className="text-red-500 font-bold">{drCr}</span>}
        />
    </>);
};

export default AccountList;
